import script from "./TemplateManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateManagementView.vue?vue&type=script&setup=true&lang=js"

import "./TemplateManagementView.vue?vue&type=style&index=0&id=5fc28d5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc28d5f"]])

export default __exports__